import React, { useEffect, useState } from "react";
import "./CoordinatorProfiles.css";
import { useDispatch, useSelector } from "react-redux";
import { ShowAllCoordinatorProfiles } from "../../../../context/Slice/CoordinatorManagementSlice";
import { Button } from "@mui/material";
import { FaUser, FaCalendarAlt, FaStar, FaLanguage, FaTransgender, FaCity } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { jwtDecode } from "jwt-decode";

const CoordinatorProfiles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const AllEventCoordinator = useSelector(
    (state) => state.CoordinatorManagementR.Data || []
  );
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const location = useLocation();
  const token = secureLocalStorage.getItem("token");

  const [userId, setUserId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [languageQuery, setLanguageQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setUserId(decoded._id || null);
    }
    dispatch(ShowAllCoordinatorProfiles());
  }, [dispatch, token]);

  // **Filter logic moved inside useEffect to avoid infinite re-renders**
  useEffect(() => {
    const filteredCoordinators =AllEventCoordinator && AllEventCoordinator?.filter((coordinator) => {
      const fullName = `${coordinator?.Coordinator.firstName} ${coordinator?.Coordinator.lastName}`;
      const cityMatch = selectedCity ? coordinator?.City === selectedCity : true;
      const languageMatch = languageQuery
        ? coordinator?.Languages.toLowerCase()?.includes(languageQuery.toLowerCase())
        : true;
      const nameMatch = fullName.toLowerCase().includes(searchQuery.toLowerCase());
      const statusMatch = coordinator?.Coordinator?.status === "active"; 

      return cityMatch && languageMatch && nameMatch && statusMatch;
    });

    setFilteredData(filteredCoordinators);
  }, [AllEventCoordinator, selectedCity, searchQuery, languageQuery]);

  const getImagePath = (imageData) => {
    try {
      const images = JSON.parse(imageData);
      if (images && images.length > 0) {
        return `${BASE_URL}/uploads/${images[0].filename}`;
      }
    } catch (error) {
      console.error("Error parsing coordinator image:", error);
    }
    return "assets/dummyProfile.jpg";
  };

  return (
    <div id="CoordinatorProfiles">
      <Button
        variant="contained"
        color="secondary"
        onClick={() => navigate("/admin-dashboard")}
        sx={{ position: "absolute", top: "20px", left: "20px" }}
      >
        Back
      </Button>

      <div className="row align-items-center">
        <div className="centered-container card-container-heading">
          <h2 className="section-heading">Event Coordinator</h2>
          <div className="filter-container">
            <input
              type="text"
              placeholder="Search by name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <div className="right-filters">
              <select className="filter-select" value={selectedCity} onChange={(e) => setSelectedCity(e.target.value)}>
                <option value="">Filter by City</option>
                {Array.isArray(AllEventCoordinator) &&
  [...new Set(AllEventCoordinator.map((coordinator) => coordinator.City))].map(
    (city, index) => (
      <option key={index} value={city}>
        {city}
      </option>
    )
  )}

              </select>
              <input
                type="text"
                placeholder="Filter by Language"
                value={languageQuery}
                onChange={(e) => setLanguageQuery(e.target.value)}
                className="filter-input"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container profile-page">
        <div className="row card-container">
          {filteredData.length === 0 ? (
            <p>No coordinators found.</p>
          ) : (
            filteredData.map((coordinator, index) => (
              <div className="col-xl-6 col-lg-7 col-md-12" key={index}>
                <div className="card profile-header">
                  <div className="body">
                    <div className="row g-[20px]">
                      <div className="col-lg-4 col-md-4 col-12">
                        <div className="profile-image float-md-right mt-3">
                          <img
                            src={getImagePath(coordinator?.CoordinatorsImage)}
                            alt={`${coordinator.Coordinator.firstName || "Default"} ${coordinator.Coordinator.lastName || "Profile"}`}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = "/assets/dummyProfile.jpg";
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-8 col-md-8 col-12">
                        <p><FaUser className="me-2" /><strong>Full Name: </strong> {coordinator.Coordinator.firstName} {coordinator.Coordinator.lastName}</p>
                        <p><FaCalendarAlt className="me-2" /><strong>Email: </strong> {coordinator.Coordinator.email}</p>
                        <p><FaCalendarAlt className="me-2" /><strong>Mobile Number: </strong> {coordinator.Coordinator.mobile_number}</p>
                        <p><FaCalendarAlt className="me-2" /><strong>Experience: </strong> {coordinator.Experience}</p>
                        <p><FaCity className="me-2" /><strong>City: </strong> {coordinator.City}</p>
                        <p><FaStar className="me-2" /><strong>Rating: </strong> {coordinator.Rating}</p>
                        <p><FaLanguage className="me-2" /><strong>Languages: </strong> {JSON.parse(coordinator.Languages).join(", ")}</p>
                        <p><FaTransgender className="me-2" /><strong>Gender: </strong> {coordinator.Gender}</p>
                        <p><FaTransgender className="me-2" /><strong>Status: </strong> {coordinator.Status}</p>
                        <p><FaTransgender className="me-2" /><strong>Active: </strong> {coordinator.Is_Active ? "Yes" : "No"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default CoordinatorProfiles;
